import React from 'react';
import style from './style';

const Label = ({...props}) => <style.Primary {...props}/>;
const BlackLabel = ({...props}) => <style.Black {...props}/>;
const OnPrimaryLabel = ({...props}) => <style.OnPrimary {...props}/>;
const BlueLabel = ({...props}) => <style.Blue {...props}/>;
const YellowLabel = ({...props}) => <style.Yellow {...props}/>;
const RedLabel = ({...props}) => <style.Red {...props}/>;

export {Label,OnPrimaryLabel,BlackLabel,BlueLabel,YellowLabel,RedLabel};